export class Events {
	constructor() {
		document.querySelectorAll('.events[data-ajax="1"]').forEach((root) => {
			this.bind(root);
		});
	}

	bind(root) {
		const config = window.icarEvents;

		if (!config?.ajaxUrl) {
			return;
		}

		const results = root.querySelector('.events__results');

		if (!results) {
			return;
		}

		const defaultPerPage = root.dataset.defaultPerPage || '12';

		const fetchResults = async (params, { updateUrl = true, scroll = false } = {}) => {
			root.classList.add('is-loading');

			const body = new FormData();
			body.append('action', config.action);
			body.append('nonce', config.nonce);

			Object.entries(params).forEach(([key, value]) => {
				if (value !== undefined && value !== null && value !== '') {
					body.append(key, String(value));
				}
			});

			try {
				const response = await fetch(config.ajaxUrl, {
					method: 'POST',
					body,
					credentials: 'same-origin',
				});

				const payload = await response.json();

				if (!payload?.success) {
					return;
				}

				results.innerHTML = payload.data.html;

				if (updateUrl) {
					this.updateUrl(params, defaultPerPage);
				}

				if (scroll) {
					root.scrollIntoView({ behavior: 'smooth', block: 'start' });
				}
			} finally {
				root.classList.remove('is-loading');
			}
		};

		const getCurrentState = () => {
			const perPageSelect = root.querySelector('.events__per-page-select');

			return {
				posts_per_page: perPageSelect?.value || defaultPerPage,
				paged: '1',
			};
		};

		root.addEventListener('click', (event) => {
			const pageLink = event.target.closest('.events__pagination a');

			if (pageLink && root.contains(pageLink)) {
				event.preventDefault();

				const state = getCurrentState();
				state.paged = String(this.getPageFromLink(pageLink));

				fetchResults(state, { scroll: true });
			}
		});

		root.addEventListener('change', (event) => {
			const select = event.target.closest('.events__per-page-select');

			if (!select || !root.contains(select)) {
				return;
			}

			const state = getCurrentState();
			state.posts_per_page = select.value;
			state.paged = '1';

			fetchResults(state, { scroll: true });
		});
	}

	getPageFromLink(anchor) {
		const url = new URL(anchor.href, window.location.origin);
		const queryPage = url.searchParams.get('paged');

		if (queryPage) {
			return Math.max(1, parseInt(queryPage, 10));
		}

		const pathMatch = url.pathname.match(/\/page\/(\d+)\/?$/);

		if (pathMatch) {
			return Math.max(1, parseInt(pathMatch[1], 10));
		}

		return 1;
	}

	updateUrl(params, defaultPerPage = '12') {
		const url = new URL(window.location.href);

		url.searchParams.delete('posts_per_page');
		url.searchParams.delete('paged');

		if (params.posts_per_page && params.posts_per_page !== defaultPerPage) {
			url.searchParams.set('posts_per_page', params.posts_per_page);
		}

		if (params.paged && params.paged !== '1') {
			url.searchParams.set('paged', params.paged);
		}

		window.history.pushState({}, '', url);
	}
}
